<template>
  <section>
    <!-- Listing Header -->
    <resources-header @search="search" @add="addResource" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <div class="custom-add"></div>
      <z-table
        :value="resources"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-60-center">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="getResource(props.row)">edit</a>
          </td>
          <td>{{ props.row.name }}</td>
          <td
            class="custom-column-60"
            @mouseenter="showSpin = props.row.id"
            @mouseleave="showSpin = null"
          >
            <z-stepper
              v-if="showSpin === props.row.id"
              @clickUp="stepperClickedUp(props.row)"
              @clickDown="stepperClickedDown(props.row)"
            />
          </td>
          <td><a href="#" @click="confirmRemoval(props.row.id)">remove</a></td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <resource-dialog
      id="resource-modal"
      :show="actionResource"
      @close="closeModal"
      @saved="savedResource"
    />
    <confirm-delete
      :show="actionDelete"
      :confirmTitle="confirmTitle"
      :confirmAction="confirmAction"
      :confirmQuestion="confirmQuestion"
      @closing="closeModal"
      @proceed="performDeletion"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ResourcesHeader from '@/Components/Resources/resources-header'
import ResourceDialog from '@/Components/Resources/forms/resource-dialog'
import ZStepper from '@/Components/ZElements/Stepper'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'resources-listing',
  components: {
    ZTable,
    ResourcesHeader,
    ResourceDialog,
    ZStepper,
    ConfirmDelete,
  },
  data() {
    return {
      page: 1,
      actionResource: null,
      isLoading: false,
      showSpin: null,
      currentId: null,
      confirmTitle: 'Remove Resource',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this Resource',
      actionDelete: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.currentId = null
    this.setPager({
      name: 'page',
      value: 1,
    })
    this.setPager({
      name: 'search',
      value: '',
    })
    await this.getLibraryName(this.examineOrganization.id)
    await this.search()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('resources', [
      'resources',
      'resource',
      'pager',
      'libraryName',
    ]),
    tableColumns() {
      return [
        {
          field: 'id',
          label: 'Id',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'name', label: 'Name', sortable: true },
        {
          field: 'priority',
          label: 'sort',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('resources', [
      'getResources',
      'editResource',
      'resetResource',
      'setResourceData',
      'removeResource',
      'setPager',
      'getLibraryName',
      'savePriorities',
    ]),
    closeModal() {
      this.actionResource = null
      this.actionDelete = null
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        await this.getResources({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
          orgId: this.examineOrganization.id,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    async stepperClickedUp(row) {
      this.showSpin = null
      this.setResourceData({
        name: 'sort',
        value: row.id,
        direction: 'up',
      })
      this.showSpin = null
      // call save
      let priorities = []
      this.resources.forEach((element) => {
        priorities.push({
          id: element.id,
          priority: element.priority,
        })
      })
      await this.savePriorities({
        priorities: priorities,
      })
    },
    async stepperClickedDown(row) {
      this.showSpin = null
      this.setResourceData({
        name: 'sort',
        value: row.id,
        direction: 'down',
      })
      this.showSpin = null
      // call save
      let priorities = []
      this.resources.forEach((element) => {
        priorities.push({
          id: element.id,
          priority: element.priority,
        })
      })
      await this.savePriorities({
        priorities: priorities,
      })
    },
    async addResource() {
      let data = {
        id: null,
        name: null,
        orgId: this.examineOrganization.id,
      }
      this.resetResource()
      this.setResourceData({
        name: 'orgid',
        value: this.examineOrganization.id,
      })
      this.actionResource = {
        isAdd: true,
        data: data,
      }
    },
    async getResource(row) {
      let data = {
        id: row.id,
        name: row.name,
        orgId: this.examineOrganization.id,
      }
      await this.editResource(data.id)
      this.actionResource = {
        isAdd: false,
        data: data,
      }
    },
    async savedResource() {
      this.closeModal()
      await this.search()
    },
    confirmRemoval(id) {
      this.currentId = id
      this.actionDelete = true
    },
    async performDeletion() {
      await this.removeResource({
        resource_id: this.currentId,
        orgId: this.examineOrganization.id,
      })
      this.actionDelete = null
      await this.search()
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.column-header {
  height: 2em;
  line-height: 2em;
  position: relative;
}
.cursor {
  cursor: pointer;
}
.sort-base {
  color: #ddd;
}
.row-highlight {
  cursor: pointer;
}
.table-row-center {
  text-align: center;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
.custom-lines {
  position: relative;
  text-align: center;
  margin: 0 auto;
  color: #0d6efd;
  cursor: grab;
}
</style>
